import { defineComponent as be, useSlots as ye, defineAsyncComponent as M, computed as o, useAttrs as he, ref as I, createElementBlock as d, openBlock as u, normalizeClass as w, createVNode as R, createCommentVNode as L, unref as h, createSlots as q, withCtx as b, withDirectives as x, createBlock as D, resolveDynamicComponent as ke, mergeProps as G, createElementVNode as ge, toDisplayString as f, Fragment as _, renderList as N, createTextVNode as H, Suspense as we, renderSlot as Le, vShow as _e, nextTick as Se } from "vue";
import { RevPopover as $e } from "@ds/components/Popover";
import { deprecatePropNames as Ve } from "../../composables/usePropsDeprecation.js";
import { usePropsValidation as Ce } from "../../composables/usePropsValidation.js";
import { vFocus as J } from "../../directives/focus.js";
import { isEmpty as c } from "../../utils/isEmpty.js";
import { isEqual as j } from "../../utils/isEqual.js";
import { omit as Ie } from "../../utils/omit.js";
import { tw as n } from "../../utils/tailwind.js";
import { componentHasFocus as xe } from "./InputSelect.helpers.js";
import De from "./components/InputSelectButton.vue2.js";
import Ne from "./components/InputSmallSelectButton.vue2.js";
const Be = ["id", "aria-label", "disabled", "hidden", "value"], Pe = ["id", "selected"], Te = ["disabled", "label"], ze = ["disabled", "selected", "value"], Oe = ["disabled", "selected", "value"], Ee = ["id"], We = /* @__PURE__ */ be({
  name: "RevInputSelect",
  inheritAttrs: !1,
  __name: "InputSelect",
  props: {
    autofocus: { type: Boolean, default: !1 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    id: {},
    customListId: { default: "" },
    label: {},
    options: {},
    modelValue: {},
    size: { default: "medium" },
    variant: { default: "default" }
  },
  emits: ["change", "update:modelValue"],
  setup(Q, { emit: U }) {
    const t = Q, B = ye(), S = U, W = M(
      () => import("../List/List.vue.js")
    ), X = M(
      () => import("./components/InputSelectItem.vue.js")
    ), Y = o(() => Ie(he(), ["class"])), p = o(
      () => !!B.optionPrefix || !!t.customListId
    );
    Ce({
      "If you choose to use a custom list, the `customListId` is required": () => !!B.optionPrefix && !t.customListId
    });
    const k = (e, l, a = "") => {
      const r = typeof e == "string" ? {
        disabled: !1,
        label: e,
        value: e
      } : e;
      return {
        key: `${c(a) ? "" : `${a}/`}${r.label}-${l}`,
        ...r
      };
    }, Z = I(null), m = o(
      () => t.size === "small" || t.variant === "tiny"
    ), $ = I(!1), P = () => {
      $.value = !1;
    }, T = () => {
      $.value = !0;
    }, z = o(() => t.options.some(
      (e) => JSON.stringify(e).includes(JSON.stringify(t.modelValue))
    )), ee = o(
      () => m.value ? `${t.id}-label-option` : void 0
    ), te = o(
      () => m.value ? t.label : void 0
    ), le = o(() => c(t.options) ? [] : t.options.filter((e) => {
      const { group: l, options: a } = e;
      return l && !c(a);
    }).reduce((e, l) => {
      const a = l, r = `${a.label}-${t.options.indexOf(l)}`;
      return [
        ...e,
        {
          disabled: a.disabled,
          key: r,
          label: a.label,
          options: a.options.map(
            (i, s) => k(i, s, r)
          )
        }
      ];
    }, [])), O = o(() => c(t.options) ? [] : t.options.filter((e) => !e.group).reduce((e, l) => [
      ...e,
      k(l, t.options.indexOf(l))
    ], [])), V = o(() => [
      ...O.value,
      ...le.value.reduce(
        (e, { options: l }) => [
          ...e,
          ...l
        ],
        []
      )
    ]), ae = o(() => c(t.options) ? [] : t.options.map((e, l) => {
      if (e.group) {
        const a = e, r = `${a.label}-${l}`;
        return {
          disabled: a.disabled,
          key: r,
          label: a.label,
          options: a.options.map(
            (i, s) => k(i, s, r)
          )
        };
      }
      return k(e, l);
    })), se = (e) => e.options !== void 0, oe = o(
      () => m.value ? Ne : De
    ), g = o(() => !c(t.error)), E = o(
      () => g.value ? t.error : t.description
    ), re = o(() => {
      if (g.value)
        return g.value && `${t.id}_error`;
    }), ie = (e) => {
      S("change", e);
      const l = V.value.find(
        ({ key: a }) => a === e.target.value
      );
      l !== void 0 && !c(l) && S("update:modelValue", l.value);
    }, ue = (e) => {
      S("update:modelValue", e.value);
    }, v = o(() => {
      const e = V.value.find(
        ({ value: l }) => j(t.modelValue, l)
      );
      return e !== void 0 && !c(e) ? e.key : null;
    }), A = I([]), ne = async (e, l, a) => {
      if (xe(e)) {
        if (await Se(), v.value === l.key) {
          e.focus();
          return;
        }
        !v.value && a === 0 && e.focus();
      }
    };
    function F({
      isOpen: e,
      hide: l,
      show: a
    }) {
      return e ? l() : a();
    }
    const de = (e, { isOpen: l, hide: a, show: r }) => {
      e.key === "Enter" && (e.preventDefault(), e.stopPropagation(), F({ isOpen: l, hide: a, show: r }));
    }, ce = o(
      () => !m.value && !c(E.value)
    ), C = o(() => {
      const e = V.value.find(
        ({ value: l }) => j(t.modelValue, l)
      );
      return e !== void 0 && !c(e) ? e.label : null;
    }), me = o(() => [
      n`block w-full cursor-pointer pl-12`,
      m.value ? n`!leading-body-1-bold body-2-bold my-4 h-full pr-40` : n`body-1 pt-20`,
      t.disabled ? n`text-static-default-low-disabled` : n`text-static-default-hi`
    ]), fe = n`!leading-body-1-bold body-2-bold size-full cursor-pointer pl-12 pr-40 pt-4`, K = o(() => m.value ? t.label : ""), pe = o(() => [
      n`body-2 mt-8`,
      t.disabled && n`text-static-default-low-disabled`,
      !t.disabled && t.error && n`text-static-danger-hi`,
      !t.disabled && !t.error && n`text-static-default-low`
    ]), ve = o(() => [
      n`rounded-sm w-full cursor-pointer appearance-none border-0 bg-transparent pl-12 text-inherit outline-none`,
      m.value ? n`body-1-bold h-full pr-40` : n`body-1 pt-20`
    ]);
    return Ve([
      {
        reason: "Replaced by `size`, with new values `medium` (for `default`) and `small` (for `tiny`).",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "variant",
          propValue: t.variant,
          propDefaultValue: "default"
        }
      }
    ]), (e, l) => (u(), d("div", {
      class: w(["relative", e.$attrs.class])
    }, [
      R(h($e), {
        "content-class-names": "z-10 w-full",
        position: "bottom-start"
      }, q({
        trigger: b(({ hide: a, isOpen: r, show: i }) => [
          x((u(), D(ke(oe.value), G({
            ...p.value ? {
              "aria-expanded": r,
              "aria-controls": e.customListId,
              role: "combobox",
              onClick: () => F({ isOpen: r, hide: a, show: i }),
              onKeyDown: (s) => de(s, { isOpen: r, hide: a, show: i }),
              onBlur: P,
              onFocus: T
            } : {
              tabindex: -1
            }
          }, {
            disabled: e.disabled,
            focused: $.value,
            "has-error": g.value,
            "has-selected-option": z.value,
            "select-id": e.id
          }), q({
            value: b(() => [
              x((u(), d("select", G({ id: e.id }, Y.value, {
                ref_key: "select",
                ref: Z,
                "aria-label": te.value,
                class: ve.value,
                disabled: e.disabled,
                hidden: p.value,
                value: v.value,
                onBlur: P,
                onChange: ie,
                onFocus: T
              }), [
                ge("option", {
                  id: ee.value,
                  class: "bg-action-default-low text-static-default-hi",
                  disabled: "",
                  hidden: "",
                  selected: !z.value,
                  value: ""
                }, f(K.value), 9, Pe),
                (u(!0), d(_, null, N(ae.value, (s) => (u(), d(_, null, [
                  se(s) ? (u(), d("optgroup", {
                    key: `group_${s.key}`,
                    disabled: s.disabled,
                    label: s.label
                  }, [
                    (u(!0), d(_, null, N(s.options, (y) => (u(), d("option", {
                      key: y.key,
                      class: "bg-action-default-low text-static-default-hi",
                      disabled: y.disabled,
                      selected: y.key === v.value,
                      value: y.key
                    }, f(y.label), 9, ze))), 128))
                  ], 8, Te)) : (u(), d("option", {
                    key: s.key,
                    class: "bg-action-default-low text-static-default-hi",
                    disabled: s.disabled,
                    selected: s.key === v.value,
                    value: s.key
                  }, f(s.label), 9, Oe))
                ], 64))), 256))
              ], 16, Be)), [
                [h(J), e.autofocus && !p.value]
              ]),
              p.value && !C.value && m.value ? (u(), d("p", {
                key: 0,
                class: w(fe)
              }, f(K.value), 1)) : L("", !0),
              p.value && C.value ? (u(), d("output", {
                key: 1,
                class: w(me.value)
              }, f(C.value), 3)) : L("", !0)
            ]),
            _: 2
          }, [
            m.value ? void 0 : {
              name: "label",
              fn: b(() => [
                H(f(e.label), 1)
              ]),
              key: "0"
            }
          ]), 1040, ["disabled", "focused", "has-error", "has-selected-option", "select-id"])), [
            [h(J), e.autofocus && p.value]
          ])
        ]),
        _: 2
      }, [
        p.value ? {
          name: "content",
          fn: b(({ isOpen: a, hide: r }) => [
            a ? (u(), D(we, { key: 0 }, {
              default: b(() => [
                x(R(h(W), {
                  id: e.customListId,
                  "aria-multiselectable": !1,
                  class: "bg-action-default-low shadow-long rounded-sm mt-8 overflow-y-auto",
                  role: "listbox"
                }, {
                  default: b(() => [
                    (u(!0), d(_, null, N(O.value, (i, s) => (u(), D(h(X), {
                      key: s,
                      id: `${i.label}-${s}`,
                      ref_for: !0,
                      ref_key: "customListItems",
                      ref: A,
                      "is-selected": i.key === v.value,
                      "items-center": !0,
                      label: i.label,
                      option: i,
                      onSelect: (y) => (ue(i), r()),
                      onVnodeMounted: () => ne(
                        A.value[s],
                        i,
                        s
                      )
                    }, {
                      prefix: b(() => [
                        Le(e.$slots, "optionPrefix", {
                          index: s,
                          isSelected: i.key === v.value,
                          option: i
                        }, () => [
                          l[0] || (l[0] = H(f("")))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "is-selected", "label", "option", "onSelect", "onVnodeMounted"]))), 128))
                  ]),
                  _: 2
                }, 1032, ["id"]), [
                  [_e, a && !t.disabled]
                ])
              ]),
              _: 2
            }, 1024)) : L("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024),
      ce.value ? (u(), d("p", {
        key: 0,
        id: re.value,
        class: w(pe.value)
      }, f(E.value), 11, Ee)) : L("", !0)
    ], 2));
  }
});
export {
  We as default
};
